import React from 'react';

const Content = ( {title, text, type} ) => {
  return(
    <div
      className={"text__wrapper " + type}
    >
      { title && (
        <div className="subtitle">{title}</div>)
      }
      <div className="p" dangerouslySetInnerHTML={{__html: text}} />
    </div>
  )
}

export default Content;